import { Environment } from './environment.model';

export const environment: Environment = {
  production: true,
  debugMode: false, // ✅ Disable debug logs in production
  apiUrl: 'https://api.gatherco.com.au/v3/',
  // Name of the readable double-submit CSRF cookie this console echoes back in X-XSRF-TOKEN.
  // Scoped per-CLIENT ('-admin') and per-ENVIRONMENT, mirroring the auth cookie names, so the
  // console never shares one token with the customer site or with another environment.
  // It MUST track the `apiUrl` above: the suffix comes from that API's YII_ENV
  // (prod -> '', stage -> '_stage', dev -> '_dev'). Repoint apiUrl and you must repoint this.
  csrfCookieName: 'XSRF-TOKEN-admin',
  nodeApiUrl: 'https://api2.gatherco.com.au/api/v1/',
  socketUrl: 'https://api2.gatherco.com.au',
  clientId: '15072021002',
  frontendClientId: '15072021001',
  grantType: 'password',
  base64Alphabet: 'neuDFUWMTb07XGpsKxy4w+oiSRHCa3j2NcZvIALErtfO8V/gdmz5Q1Y6qP9JklBh',
  userTypeTrade: 'Trade',
  userTypeGeneral: 'General',
  facebookAppId: '840587173156641',
  googleClientId: '818998394662-tt1fucr9omf2a8m8l00jdecd2fqe8hhb.apps.googleusercontent.com',
  imageKitEndpoint: 'https://ik.imagekit.io/gatherco',
  hostUrl: "https://gatherco.com.au", // URL where this app is hosted
  guestPaymentUrl: "https://www.gatherco.com.au/guest/payment",
  imageKitAssetFolder: "WEBSITE_ASSETS",
  emailImageUrl: 'https://api.gatherco.com.au/images/email-template/v2/', // used for display images into email template
  googleMapKey: 'AIzaSyBmrteJJkGW97DAtSk7mw8Sm8TrtE-ncqU',
  frontendHostUrl: "https://www.gatherco.com.au",
  aiApiUrl: "https://ai.gatherco.com.au/",
  baDashboardUrl: "https://ba.gatherco.com.au/dashboard",
  // FEATURE FLAG: Storage Fees - Set to true to enable, false to disable
  storageFeesEnabled: true
};
